import { useEffect, useReducer } from 'react';
import axios from 'axios';
import { dataFetchReducer } from './utils/dataFetchReducer';
import { systemCode, xs_languageCode } from '..';
import { parseWidgetData } from './parseWidgetData';
import { getConfiguration } from './utils/configuration';

export function useFetchWidgets(shouldExecute, forceMatchWidget) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        if (!shouldExecute) {
            return;
        }
        
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.getWidgetCentrali;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: ''
        };
        fetchData(url, params, function(response) {
            const data = parseWidgetData(response, forceMatchWidget);
            dispatch({ type: 'FETCH_SUCCESS', payload: data });
        });

        return () => {
            didCancel = true;
        };
    }, []);

    return [state, dispatch];
}
